import { HttpInterceptorFn, HttpRequest, HttpErrorResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, from, switchMap, throwError } from 'rxjs';
import { AuthService } from './auth.service';

function addAuthHeader(req: HttpRequest<unknown>, token: string | null): HttpRequest<unknown> {
    if (!token) return req;
    return req.clone({ setHeaders: { Authorization: `Bearer ${token}` } });
}

function isAuthEndpoint(url: string): boolean {
    return url.includes('/auth/login') || url.includes('/auth/refresh') || url.includes('/auth/logout');
}

export const authInterceptor: HttpInterceptorFn = (req, next) => {
    // No tocar los endpoints de auth (login, refresh, logout):
    // login no necesita Bearer; refresh usa cookie; intentar refrescar en un 401
    // de refresh sería loop infinito.
    if (isAuthEndpoint(req.url)) {
        return next(req);
    }

    const auth = inject(AuthService);
    const reqWithAuth = addAuthHeader(req, auth.accessToken());

    return next(reqWithAuth).pipe(
        catchError((err: HttpErrorResponse) => {
            if (err.status !== 401) return throwError(() => err);

            // Intentamos refrescar una vez. Si funciona, reintentamos el request.
            return from(auth.refresh()).pipe(
                switchMap((ok) => {
                    if (ok) {
                        return next(addAuthHeader(req, auth.accessToken()));
                    }
                    // Refresh falló: fuerza logout (que redirige a /auth/login).
                    auth.logout();
                    return throwError(() => err);
                })
            );
        })
    );
};
